import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import SearchResultEntity from "../../../../domain/entities/SearchResultEntity";
import StablishmentEntity from "../../../../domain/entities/StablishmentEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import StablishmentDto from "../../../dto/StablishmentDto";

const SearchStablishmentsApiImpl = async (_: {
    query?: string, 
    page: number, 
    itemsPerPage: number
}): Promise<Either<ErrorEntity, SearchResultEntity<StablishmentEntity>>> => {
    try {
        let relativeUrl: string = `/stablishments?`;
        
        if (_.query != undefined && _.query.length > 0) {
            relativeUrl += `name=${encodeURIComponent(_.query)}&`;
        }
        if (_.page != undefined) {
            relativeUrl += `page=${_.page}&`;
        }
        if (_.itemsPerPage != undefined) {
            relativeUrl += `per_page=${_.itemsPerPage}&`;
        }

        if (relativeUrl.endsWith('&') || relativeUrl.endsWith('?')) {
            relativeUrl = relativeUrl.slice(0, -1);
        }

        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        
        const parsed = response.stablishments.map((item: any) => StablishmentDto.fromJSON(item));
        return right({
            data: parsed,
            itemsPerPage: _.itemsPerPage,
            page: _.page,
            pages: Math.ceil(response.total / _.itemsPerPage),
            total: response.total,
        });
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default SearchStablishmentsApiImpl;